import {IPartner, IPartnersState} from "./Helper";
import {SliceNames} from "../constants";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {getPartners} from "./ActionCreators";

const initialValue: IPartnersState = {
    partners: [],
    loading: false
}

const partnersSlice = createSlice({
    name: SliceNames.PARTNER,
    initialState: initialValue,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(
            getPartners.pending, (state) => {
                state.loading = true
            })
            .addCase(
                getPartners.fulfilled, (state, action: PayloadAction<IPartner[]>) => {
                    state.partners = action.payload
                    state.loading = false
                })
            .addCase(
                getPartners.rejected, (state) => {
                    state.loading = false
                })
    }
})

export default partnersSlice.reducer